// constants.js - Global constants used across the application

export const PRAYER_CATEGORIES = [
  "Health",
  "Salvation",
  "Family",
  "Thanks",
  "Guidance",
  "Provision",
  "Relationships"
];
